import React, { useEffect, useState } from "react";
import { vritix_logo, tms_404, tms_500 } from "../../assets/images/tms-image-list";
import "../../assets/css/tms-common/tms-common.scss";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { withRouter } from "../../utils/tms-with-router/tms-with-router";
const TmsErrorPage = ({ router }) => {
  const [errorType, setErrorType] = useState("");
  useEffect(() => {
    let { error } = router.params;
    setErrorType(error);
  }, []);
  const errorDesc = {
    404: { desc: "404 Page not found", image: tms_404 },
    500: { desc: "500 Internal Service Error", image: tms_500 },
    403: { desc: "403 Forbidden", image: "IMG" },
  };
  return (
    <div className="outer-wrapper">
      <div className="ow-right">
        <img src={vritix_logo} className="ow-logo" alt="error" />
        <h2 className="ow-h2">
          Endowments Portal
          <br />
          Andhra Pradesh
        </h2>
        <img src={errorDesc[errorType]?.image} />
        <div>{errorDesc[errorType]?.desc}</div>
        <br />
        <div className="ow-back-arrow-text">
          <Link
            onClick={() => {
              router.navigate(-1);
            }}
          >
            <ArrowLeftOutlined /> Back
          </Link>
        </div>
        <p className="ow-reserved">
          © {new Date().getFullYear()} All rights reserved{" "}
        </p>
      </div>
    </div>
  );
};
export default withRouter(TmsErrorPage);
